module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module3-3.d0d13ff9.jpg";